import React, { Component } from 'react';

const Label = (props) => {
    return (
    <div>
        <label className="label">{props.name}:</label>
    </div>
    );
}

export default Label


// WEBPACK FOOTER //
// ./src/components/Label.js